const initialState = {
    bookingLoading: false,
    showLoading: true,
    searchLoading: true,
    searchData: null,
};

export default initialState;
